export enum LoginPageWarnings {
  EMPTY_USERNAME_FIELD = "Please enter your username",
  EMPTY_PASSWORD_FIELD = "Please enter your password",
}
